const { createContext } = require("react");

export const Transcontext = createContext()

//this was use to avoid rerendering